document.addEventListener("DOMContentLoaded", function () {
  const productWishButtons = document.querySelector(".swym-button_product");
  if (!productWishButtons) return;

  productWishButtons.addEventListener("click", function () {
    const productId = productWishButtons.getAttribute("data-product-id");
    const variantId = productWishButtons.getAttribute("data-variant-id");
    const productUrl = productWishButtons.getAttribute("data-product-url");

    const product = {
      empi: productId,
      epi: variantId,
      du: productUrl,
    };

    productHandleSingleWishlist(product, productWishButtons);
  });
});

function productHandleSingleWishlist(product, button) {
  if (!window.globalListArray || !globalListArray[0]) {
    window.addEventListener('wishlistdata', function handler() {
      window.removeEventListener('wishlistdata', handler);
      productHandleSingleWishlist(product, button);
    });
    return;
  }

  const lid = globalListArray[0].lid;

  if (!button.classList.contains("swym-added")) { 
    _swat.addToList(lid, product, 
      function(response) {
        console.log('✅ addToList success:', JSON.stringify(response));
        button.classList.toggle("swym-added");
      }, 
      function(error) {
        console.error('❌ addToList error:', JSON.stringify(error));
      }
    );
  } else {
    _swat.deleteFromList(lid, product,
      function(response) {
        console.log('✅ deleteFromList success:', JSON.stringify(response));
        button.classList.toggle("swym-added");
      },
      function(error) {
        console.error('❌ deleteFromList error:', JSON.stringify(error));
      }
    );
  }
}